import { memo } from 'react'

const message = '404 Page not found'

export const PageNotFound = memo(() => <h2>{message}</h2>)

PageNotFound.displayName = 'PageNotFound'
